import { hashKey, type QueryClient, type QueryKey } from '@tanstack/react-query';

export const clearAuthScopedQueries = async (queryClient: QueryClient, preservedQueryKeys: QueryKey[]): Promise<void> => {
    const preservedQueryHashes = new Set(preservedQueryKeys.map((queryKey) => hashKey(queryKey)));
    const shouldClearQuery = (query: { queryHash: string }): boolean => !preservedQueryHashes.has(query.queryHash);

    await queryClient.cancelQueries({ predicate: shouldClearQuery });
    queryClient.removeQueries({ predicate: shouldClearQuery });
};
